module.exports = __webpack_public_path__ + "5399fda9f98c5b36a4420ef716e5935e.png";